module.exports = __webpack_public_path__ + "static/intermountain-1-b81468f54f1b9d6df9b0e719fd73e5a3.png";